import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ClassEnrolment } from '../../../models/class-enrolment.model';

@Component({
    selector: 'app-enrolment-confirmation',
    templateUrl: './enrolment-confirmation.component.html',
    styleUrls: ['./enrolment-confirmation.component.scss'],
    standalone: false
})
export class EnrolmentConfirmationComponent {
  enrolmentForm: FormGroup;
  enrolmentDto: ClassEnrolment;
  bannerLabel: string = '';
  displayLabel: string = '';
  email: string = ''

  @Input() set Enrolment(v: ClassEnrolment) {
    this.enrolmentDto = v;
    this.enrolmentForm = new FormGroup({ note: new FormControl(v.MessageForLearner) }); 
  }
  @Input() set Email(v: string) { 
    this.email = v
    if (this.bannerLabel) this.displayLabel = this.bannerLabel.replace('{0}', v); 
  }
  @Output() messageUpdated = new EventEmitter<ClassEnrolment>();
  
  @Input() isEditMode: boolean = false

  constructor(public translateService: TranslateService) { }

  ngOnInit(): void {
    this.translateService.get('ClassEnrolment.EnrolmentNotificationBanner').subscribe((translated: string) => {
      this.bannerLabel = translated;
      this.displayLabel = this.bannerLabel.replace('{0}', this.email);
    });
  }
  update() {
    this.enrolmentDto.MessageForLearner = this.enrolmentForm.controls["note"].value;
    this.messageUpdated.emit(this.enrolmentDto);
  }
}
